<script lang="ts">
	import { format } from 'svelte-i18n';
	import { FlexibleCard, PlainTable, Button } from '@Shelly/shelly-design-system';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	import EvChargerStatuses from './EvChargerStatuses.svelte';
	import EvChargerManualLimit from './EvChargerManualLimit.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device: Device, statuses: VCInterfaceStatus[];
</script>

<EvChargerStatuses {statuses} />
<EvChargerManualLimit {device} {statuses} />
<FlexibleCard
	backgroundColor={$showNewLayout ? '--color-0' : undefined}
	class="mb-s"
	padding="m"
	mainContentPrioritySlot="both"
	header={$format('label_real_time_data', {
		default: 'Real-time data',
	})}
	icon="far fa-signal-stream"
>
	<PlainTable class="width-full">
		<tbody>
			{#each ['a', 'b', 'c'] as phase}
				<tr>
					<th
						>{$format(`label_phase_${phase}`, {
							default: `phase ${phase}`,
						})}</th
					>
					<td>{statuses.find((i) => i.name == `${phase}_power`)?.value || 'N/A'}</td>
				</tr>
			{/each}
		</tbody>
	</PlainTable>
	<PlainTable class="width-full">
		<Button
			variant="secondary"
			class="mt-s width-full"
			size="m"
			on:click={() => {
				navigateToSetting(device.id, 'charts');
			}}
		>
			{$format('button_view_live_consumption', {
				default: 'View live consumption',
			})}
		</Button>
	</PlainTable>
</FlexibleCard>
